import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const SystemStatus = types.compose(
  BaseEntity,
  types.model('SystemStatus', {
    systemStatusId: types.identifierNumber,
    subSystem: types.string,
    status: types.string,
    year: types.number,
    secretariatId: types.number,
  }),
);
